<template>
  <div id="user-edit-tab-info" class="page-payment-view ">
    <div title="User Information" class="mb-base">
      <!-- Avatar -->
      <div class="vx-row">
        <!-- Avatar Col -->
        <div class="vx-col border" id="avatar-col">
          <div class="img-container mb-4">
            <img :src="data_local.userdata.avatar
              ? `https://selfie.cash/avatar/${data_local.userdata.avatar}`
              : require('@/assets/images/avatar.png')
              " class="rounded border w-full" />
          </div>
        </div>
        <!-- Information - Col 1 -->
        <div class="vx-col flex-1" id="account-info-col-1">
          <table>
            <tr>
              <td class="font-semibold">Name</td>
              <td>{{ data_local.userdata.firstname }} {{ data_local.userdata.lastname }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Email</td>
              <td>{{ data_local.userdata.email }}</td>
            </tr>
            <tr>
              <td class="font-semibold">PaymentMethod</td>
              <td style="display: flex; align-items: center;">
                <img :src="`https://selfie.cash/payments/${data_local.paymentMethod}.png`"
                  style="height: 20px; margin-right: 5px;">
                {{ data_local.paymentMethod }}
              </td>
            </tr>
          </table>
        </div>
        <!-- /Information - Col 1 -->
        <!-- Information - Col 2 -->
        <div class="vx-col flex-1" id="account-info-col-2">
          <table>
            <tr>
              <td class="font-semibold">status</td>
              <td>
                <vs-chip :color="chipColor(data_local.status)">
                  <span>{{ data_local.status }}</span>
                </vs-chip>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Amount</td>
              <td>{{ '€ ' + data_local.amount }}
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Date</td>
              <td>{{ FormatDate }}</td>
            </tr>
          </table>
        </div>

        <div class="vx-col w-full flex" id="account-manage-buttons">
          <vs-button type="border" v-if="data_local.status == 'Pending'" color="success" icon-pack="feather"
            icon="icon-check" @click="pay">Paid</vs-button>
        </div>
      </div>


    </div>
    <div class="vx-row">

      <div class="vx-col lg:w-1/2 w-full">
        <div class="mb-base">
          <h4>{{ 'Selfies (€ ' + selfiesAmount + ')' }}</h4><br />
          <table v-if="transactionSelfies == null">
            <tr>
              <td class="font-semibold"> Selfie information is empty </td>
            </tr>
          </table>
          <table v-else>
            <tr v-for="data in transactionSelfies">
              <td>
                <img :src="data.url" style="width:100px; height:100px" class="rounded" />
              </td>
              <table>
                <tr>
                  <td class="font-semibold"> title </td>
                  <td> {{ data.title }} </td>
                </tr>
                <tr>
                  <td class="font-semibold"> description </td>
                  <td> {{ data.description }} </td>
                </tr>
                <tr>
                  <td class="font-semibold"> price </td>
                  <td> {{ '€ ' + data.price }} </td>
                </tr>
              </table>
            </tr>
          </table>
        </div>
      </div>
      <div class="vx-col lg:w-1/2 w-full">
        <div class="mb-base">
          <h4>{{ 'Referrals (€ ' + refersAmount + ')' }}</h4><br />
          <table v-if="!transactionRefers.length">
            <tr>
              <td class="font-semibold"> Referral information is empty </td>
            </tr>
          </table>
          <table v-else>
            <tr v-for="data in transactionRefers">
              <td>
                <img :src="`https://selfie.cash/avatar/${data.referUser.avatar}`" style="width:100px; height:100px"
                  class="rounded" />
              </td>
              <table>
                <tr>
                  <td class="font-semibold"> Name </td>
                  <td> {{ data.referUser.firstname + data.referUser.lastname }} </td>
                </tr>
                <tr>
                  <td class="font-semibold"> Email </td>
                  <td> {{ data.referUser.email }} </td>
                </tr>
                <tr>
                  <td class="font-semibold"> Country </td>
                  <td> {{ data.referUser.country == 0 ? "Netherlands" : data.referUser.country == 1 ? "United States" :
                    "Ukriane" }} </td>
                </tr>
              </table>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
export default {
  components: {
    vSelect,

  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.userData)),
      username: "",
      requestedSelfies: [],
      requestedRefers: [],
      avatar: "",

    };
  },
  computed: {
    FormatDate () {
      const date = new Date(this.data_local.date);
      return date.toLocaleString();
    },
    transactionSelfies() {
      console.log(this.data_local)
      this.requestedSelfies = this.data_local.selfiedata.filter((selfie) => selfie.transaction == this.data_local._id)
      return this.requestedSelfies;
    },
    transactionRefers() {
      this.requestedRefers = this.data_local.referralData.filter((refer) => refer.transaction == this.data_local._id)
      return this.requestedRefers;
    },
    selfiesAmount() {
      let temp = 0;
      if (this.requestedSelfies.length > 0) {
        this.requestedSelfies.map((selfie) => {
          temp += selfie.price;
        });
      }
      return temp;
    },
    refersAmount() {
      let temp = 0;
      if (this.requestedRefers.length > 0) {
        this.requestedRefers.map((refer) => {
          temp += 5;
        });
      }
      return temp;

    },
    chipColor() {
      return (value) => {
        if (value === 'Paid') return 'success'
        else return 'primary'
      }
    },
    validateForm() {
      return !this.errors.any();
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    pay() {
      this.$store
        .dispatch("userManagement/paytransaction", this.data_local._id)
        .then(() => {
          console.log("www")
          this.data_local.status = 'Paid'
          this.showPaidSuccess();
        })
        .catch((err) => {

          console.error(err);
        });
    },
    showPaidSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Pay transaction",
        text: "successfully paid",
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    save_changes() {
      /* eslint-disable */
      //      if (!this.validateForm) return;

      const payload = {
      };
      // sending file to the backendthis.$store
      this.$store
        .dispatch("userManagement/updateUser", payload)
        .then((res) => {
          this.reset_data();
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "User Upload Failed!",
            text: res.message,
          });
          console.error(err);
        });

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
    },
    update_avatar(e) {
      let files = e.target.files || e.dataTransfer.files;
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      this.data_local.avatar = file;
      reader.onload = (e) => {
        document.getElementsByClassName("avatar_image")[0].src = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeAvatar() {
      this.data_local.avatar = ""
      document.getElementsByClassName(
        "avatar_image"
      )[0].src = require("@/assets/images/avatar.png");
    },
    importData() {
      this.$router.push('/engineer/import')
    },
    exportData() {
      this.$router.push('/engineer/export')
    },
  },
  created() {
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    this.data_local = JSON.parse(JSON.stringify(this.userData))
    this.name = this.data_local.firstname + ' ' + this.data_local.lastname
    this.avatar = this.data_local.avatar
    for (var i = 0; i < this.data_local.transactioninfo.length; i++) {
      this.data_local.transactioninfo[i] = { ...this.data_local.transactioninfo[i], "avatar": this.avatar }
      this.data_local.transactioninfo[i] = { ...this.data_local.transactioninfo[i], "name": this.name }
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`
    }
  },
};
</script>


<style lang="scss">
#avatar-col {
  width: 10rem;
}

.page-payment-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}
</style>